import request from '@/utils/request';


export function optimizationAPI () {
    return {
        // 获取角色组列表
        getRoleList: params => {
            return request ({
                url: '/admin/role/index',
                method: 'get',
                params,
            });
        },
        addAndEditRole: params => {
            return request ({
                url: '/admin/role/update',
                method: 'post',
                data: params,
            });
        },
        getRoleInfo: params => {
            return request ({
                url: `/admin/role/show?id=${params}`,
                method: 'get',
            });
        },
        delRole: params => {
            return request ({
                url: `/admin/group/del?id=${params}`,
                method: 'get',
            });
        },
    };
}
